import { MoveRight } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { View, XStack } from "tamagui";
import { Block } from "../../../ui/Block";
import { Body } from "../../../ui/Body";
import { Subtext } from "../../../ui/Subtext";
import { UserAvatar, UserDisplay } from "../../../ui/UserAvatar";
import type ExpenseModuleModel from "../ExpenseModuleModel";
import type { ExpenseDebt } from "../ExpenseModuleModel";
import { DebtModal } from "./DebtModal";

export const DebtsRow: React.FC<{
  debt: ExpenseDebt;
  module: ExpenseModuleModel;
}> = observer(({ debt, module }) => {
  const [showForm, setShowForm] = useState(false);

  return (
    <Block grouped icon={<UserAvatar userUid={debt.debtorUser?.uid} />}>
      <XStack
        alignItems="center"
        gap="$medium"
        width="100%"
        onPress={() => setShowForm(true)}
      >
        <View flex={1} flexBasis={0}>
          <Body ellipse ellipsizeMode="tail">
            {debt.debtorUser?.data.displayName}
          </Body>
          <Subtext color="#e73333">
            {module.currencyFormatter.format(debt.amount.toNumber())}
          </Subtext>
        </View>
        <MoveRight width={24} />
        <View flex={1} alignItems="flex-end" flexBasis={0}>
          <UserDisplay userUid={debt.creditorUser?.uid} />
        </View>
      </XStack>
      <DebtModal
        visible={showForm}
        onClose={() => setShowForm(false)}
        debt={debt}
        module={module}
      />
    </Block>
  );
});
